module.exports = __webpack_public_path__ + "static/img/autCt_bg_white_07.d3b3e642.svg";